@if (isVariationsLoaded) {
    <cb-lot-variations-action-bar
        *cbWaitFor="lotMappedItem"
        [lotMappedItem]="lotMappedItem"
        (variationRecordCreated)="variationCreated()"
    >
    </cb-lot-variations-action-bar>
    <div class="cb-margin flex-row" style="gap: 16px">
        <cb-lot-variations-list
            *cbWaitFor="variationMappedItems"
            [variationMappedItems]="variationMappedItems"
            (variationSelected)="variationSelected($event)"
        >
        </cb-lot-variations-list>
        @if (selectedVariation) {
            <cb-lot-variation-view
                [variationMappedItem]="selectedVariation"
                (variationMappedItemUpdated)="updateSelectedVariation($event)"
                style="width: 100%"
            >
            </cb-lot-variation-view>
        }
        @if (!selectedVariation) {
            <cb-info-message message="Select a Variation to view the Variation Details">
            </cb-info-message>
        }
    </div>
}
@if (!isVariationsLoaded) {
    <cb-loading-spinner></cb-loading-spinner>
}
